import React, {memo, Suspense} from 'react';
import config from '../../service/config';
import {ToastContainer, Slide} from 'react-toastify';
import Header from '../header/Header';
import HeaderPlaceholder from '../header/HeaderPlaceholder';
import {PageWrapper} from '../util/StyledElements';
import WhatsNewView from './WhatsNewView';
import {useTscTheme} from '../../context/themeProvider';
import styled from 'styled-components';

const WhatsNewContentWrapper = styled.div`
   display: flex;
   flex-direction: row;
   width: 100%;
`;

export const WhatsNewBase: React.FC = () => {
   const theme = useTscTheme();

   return (
      <PageWrapper
         id="modal-root"
         theme={theme}
      >
         <ToastContainer
            position="top-center"
            transition={Slide}
         />
         <Suspense fallback={<HeaderPlaceholder />}>
            <Header
               hideSearch={config.featureSwitches.DisableSearch}
               hideEntitlementInfo={false}
               hideThemePicker={false}
               hideNavLinkTabs={false}
            />
         </Suspense>
         <WhatsNewContentWrapper>
            <WhatsNewView />
         </WhatsNewContentWrapper>
      </PageWrapper>
   );
};

export default memo(WhatsNewBase);